<template>
  <footer class="confirmation-footer">
    <div class="container">
      <div class="mentions-legales" v-if="showMentionLegales || route.path !== '/accessibilite'">
        En communiquant vos données ainsi que celles de votre filleul, vous acceptez que les données 
        personnelles soient traitées par Groupama Loire Bretagne, responsable de traitement, pour gérer votre 
        participation à l’opération de parrainage. Vous avez par ailleurs préalablement informé votre filleul 
        de cette collecte et avez recueilli son consentement à être contacté par un conseiller Groupama pour 
        lui proposer une offre de télésurveillance d’un partenaire.
        Le traitement de ces données personnelles est réalisé sur la base de l’intérêt légitime de l’entreprise 
        d’organiser cette opération de parrainage. Les données sont conservées le temps de l’opération de parrainage.
        Conformément à la réglementation relative à la protection des données personnelles notamment le RGPD 
        (UE 2016/679) et la loi Informatique et Libertés n° 78-17 du 6 Janvier 1978 modifiée, vous pouvez exercer 
        vos droits d’accès, de rectification, de suppression, de limitation, de portabilité et d'opposition en 
        vous adressant au Délégué à la Protection des Données de Groupama Loire Bretagne, par courrier à l’adresse : 
        23, Boulevard Solférino CS51209 35012 RENNES cedex ou par mail à l’adresse <a href="mailto:contactdrpo@groupama-loire-bretagne.fr"
          >contactdrpo@groupama-loire-bretagne.fr</a
        >.
        Il vous revient d’informer votre filleul des droits dont il dispose et des modalités d’exercice de ceux-ci.
        Pour une information détaillée concernant le traitement de vos données personnelles ou les modalités d’exercice
         de vos droits, vous pouvez consulter notre Politique de protection des données figurant sur ce site internet, 
         rubrique « Données personnelles » accessible en bas de page.
      </div>

      <div class="text-center" v-if="showMentionLegales">
        <nav>
          <ul class="footer-nav">
            <li><a href="/mentions-legales.pdf" target="_blank">Mentions légales</a></li>
            <li>
              <router-link :to="{ name: 'Accessibilite' }" target="_blank">
                Accessibilité : non conforme
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";
import { useRoute } from 'vue-router';

export default {

  setup() {
    const route = useRoute();
    
    return {
      route
    };
  },

  computed: {
    ...mapGetters({
      showMentionLegales: "isDisabled",
    }),
  },
};
</script>
<style lang="scss" scoped></style>
